import React from 'react';
import PropTypes from 'prop-types';
import styles from './flapdisplay.css';

var SplitFlap = function SplitFlap(_ref) {
  var flipping = _ref.flipping,
      currentChar = _ref.currentChar,
      nextChar = _ref.nextChar;
  var classNames = [styles.character];

  if (flipping) {
    classNames.push(styles.flipping);
  }

  return React.createElement("div", {
    className: classNames.length ? classNames.join(' ') : undefined
  }, React.createElement("div", {
    className: styles.baseTop,
    "data-content": nextChar
  }), React.createElement("div", {
    className: styles.baseBottom,
    "data-content": currentChar
  }), React.createElement("div", {
    className: styles.flap
  }, React.createElement("div", {
    className: styles.flapFront,
    "data-content": currentChar
  }), React.createElement("div", {
    className: styles.flapBack,
    "data-content": nextChar
  })));
};

export default SplitFlap;
SplitFlap.propTypes = {
  /** Boolean to animate the flap */
  flipping: PropTypes.bool,

  /** Value of the first displayed character */
  currentChar: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Value of the character revealed */
  nextChar: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
SplitFlap.defaultProps = {
  flipping: false,
  currentChar: 'G',
  nextChar: 'B'
};